<template>
  <div class="passenger-form-row">
    <div class="passenger-item-title">
      <h3>旅客{{psgIndex+1}}</h3>
      <span v-if="initValue.passengerType==='ADT'">成人（≥12岁）</span>
      <span v-else-if="initValue.passengerType==='CHD'">儿童（2岁(含)-12岁）</span>
      <span v-else-if="initValue.passengerType==='INF'">婴儿（14天(含)-2岁）</span>
      <span>
        <a-checkbox :checked="isChecked" @change="setUsual($event, psgIndex)">设为常用人</a-checkbox>
        <a-checkbox v-if="ifInviteRegisterFfp && !isInfant" :checked="isInviteChecked" @change="setInvite($event, psgIndex)">邀请注册金鹏会员</a-checkbox>
        <span class="ml-20" v-if="getPassengerTypeInfo(initValue.passengerType)">{{ getPassengerTypeInfo(initValue.passengerType) }}</span>
      </span>
    </div>
    <div class="passenger-item-content">
      <span
        v-if="psgIndex > 0"
        href="javascript:void(0);"
        class="close-passenger-item"
        @click="removePassenger(psgIndex)"
      >×</span>
      <div class="passenger-wrap clearfix">
        <a-form-item label="旅客Id" class="hidden">
          <a-input
            v-decorator="[
              `passengers[${psgIndex}].id`
            ]"
            size="large"
            hidden
          />
        </a-form-item>
        <a-form-item label="类型" class="hidden">
          <a-input
            v-decorator="[
              `passengers[${psgIndex}].passengerType`
            ]"
            size="large"
            hidden
          />
        </a-form-item>
        <a-form-item label="设为乘机人" class="hidden">
          <a-checkbox
            v-decorator="[
              `passengers[${psgIndex}].isUsual`
            ]"
            size="large"
            hidden
          ></a-checkbox>
        </a-form-item>
        <a-form-item label="邀请注册金鹏会员" class="hidden" v-if="ifInviteRegisterFfp && !isInfant">
          <a-checkbox
            v-decorator="[
              `passengers[${psgIndex}].isInvite`,
              {
                  initialValue: true,
              }
            ]"
            size="large"
            hidden
          ></a-checkbox>
        </a-form-item>
        <div class="field-outter" v-show="isDomestic || isInfant">
          <a-form-item label="姓名" required>
            <a-input
              v-decorator="[
                `passengers[${psgIndex}].fullName`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
              size="large"
              placeholder="请输入姓名"
            />
            <passenger-tooltip v-if="getPassengerFieldInfo('fullName')" :data="getPassengerFieldInfo('fullName')"></passenger-tooltip>
          </a-form-item>
        </div>
        <div class="field-outter" v-if="!isDomestic && !isInfant">
          <a-form-item label="姓" required>
            <a-input
              v-decorator="[
                `passengers[${psgIndex}].passengerLastName`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur',
                  normalize: (value) => {
                    return value && value.toUpperCase()
                  }
                }
              ]"
              @change="setFullName"
              size="large"
              placeholder="中文姓/英文姓/拼音姓"
            />
            <passenger-tooltip v-if="getPassengerFieldInfo('lastName')" :data="getPassengerFieldInfo('lastName')"></passenger-tooltip>
          </a-form-item>
        </div>
        <div class="field-outter" v-if="!isDomestic && !isInfant">
          <a-form-item label="名" required>
            <a-input
              v-decorator="[
                `passengers[${psgIndex}].passengerFirstName`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur',
                  normalize: (value) => {
                    return value && value.toUpperCase()
                  }
                }
              ]"
              @change="setFullName"
              size="large"
              placeholder="中文名/英文名/拼音名"
            />
            <passenger-tooltip v-if="getPassengerFieldInfo('firstName')" :data="getPassengerFieldInfo('firstName')"></passenger-tooltip>
          </a-form-item>
        </div>
        <div class="field-outter" v-if="initValue.passengerType==='INF'">
          <a-form-item label="婴儿携带人" required>
            <a-select
              v-decorator="[
                `passengers[${psgIndex}].adultName`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
              @focus="getAdultList"
              size="large"
              placeholder="请选择婴儿携带人"
            >
              <a-select-option v-for="adult in adultOptionList" :key="adult">{{adult}}</a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="field-outter" v-if="initValue.passengerType!=='INF'">
          <a-form-item label="证件类型" required>
            <a-select
              v-decorator="[
                `passengers[${psgIndex}].idType`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
              size="large"
              placeholder="请选择证件类型"
              @change="onIdTypeChange($event, psgIndex, true)"
            >
              <template v-if="!isAgent">
                <a-select-option v-for="(value, key) in orderCertificateMap" :value="key" :key="key" :title="value">{{ value }}</a-select-option>
              </template>
              <template v-else>
                <a-select-option v-for="(value, key) in orderCertificateDomesticMap" :value="key" :key="key" :title="value">{{ value }}</a-select-option>
              </template>
            </a-select>
            <passenger-tooltip v-if="getPassengerFieldInfo('idType')" :data="getPassengerFieldInfo('idType')"></passenger-tooltip>
          </a-form-item>
        </div>
        <div class="field-outter" v-if="!isDomestic && !isInfant">
          <a-form-item label="性别" required>
            <a-select
              v-decorator="[
                `passengers[${psgIndex}].gender`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
              size="large"
              placeholder="请选择性别"
            >
              <a-select-option value="M">男</a-select-option>
              <a-select-option value="F">女</a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="field-outter field-long" v-if="initValue.passengerType!=='INF'">
          <a-form-item label="证件号码" required>
            <a-input
              v-decorator="[
                `passengers[${psgIndex}].certificateNo`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
              size="large"
              placeholder="请输入证件号码"
            />
          </a-form-item>
        </div>
        <a-form-item label="出生日期" class="hidden">
          <a-input
            v-decorator="[
              `passengers[${psgIndex}].birthday`
            ]"
            size="large"
            hidden
          />
        </a-form-item>
        <div class="field-outter">
          <a-form-item label="出生日期" required>
            <a-date-picker
              v-decorator="[
                `passengers[${psgIndex}].birthdayObj`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
              size="large"
              placeholder="请输入出生日期"
            />
          </a-form-item>
        </div>
        <div class="field-outter" v-if="!isDomestic && !isInfant">
          <a-form-item label="国籍" required>
            <a-select
              v-decorator="[
                `passengers[${psgIndex}].nationality`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
              size="large"
              show-search
              :filter-option="filterOption"
              :options="renderedOptions"
              placeholder="请选择国籍"
              @search="handleSearch"
              @popupScroll="handlePopupScroll"
              @select="handleSelect"
            >
            </a-select>
          </a-form-item>
        </div>
        <div class="field-outter" v-if="!isDomestic && !isInfant">
          <a-form-item label="证件签发国" required>
            <a-select
              v-decorator="[
                `passengers[${psgIndex}].issueCountry`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
              size="large"
              show-search
              :filter-option="filterOption"
              :options="renderedOptions"
              placeholder="请选择证件签发国"
              @search="handleSearch"
              @popupScroll="handlePopupScroll"
              @select="handleSelect"
            >
            </a-select>
          </a-form-item>
        </div>
        <a-form-item label="证件有效期" class="hidden" v-if="!isDomestic && !isInfant">
          <a-input
            v-decorator="[
              `passengers[${psgIndex}].certExpried`
            ]"
            size="large"
            hidden
          />
        </a-form-item>
        <div class="field-outter" v-if="!isDomestic && !isInfant">
          <a-form-item label="证件有效期" required>
            <a-date-picker
              v-decorator="[
                `passengers[${psgIndex}].certExpriedObj`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
              size="large"
              placeholder="请输入证件有效期"
              :disabled-date="startDisabledDate"
              :default-picker-value="startDate(departureDate)"
              :showToday="false"
              format="YYYY-MM-DD"
            />
            <passenger-tooltip v-if="getPassengerFieldInfo('certExpried')" :data="getPassengerFieldInfo('certExpried')"></passenger-tooltip>
          </a-form-item>
        </div>
        <div class="field-outter field-long contact-mobile">
          <a-form-item label="手机号码" required>
            <a-input
              v-decorator="[
                `passengers[${psgIndex}].mobile`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
              size="large"
              placeholder="请输入手机号码"
            >
              <a-select
                class="counrty-code-select"
                showSearch
                slot="addonBefore"
                :dropdownMatchSelectWidth="false"
                :filterOption="countryCodefilter"
                :options="countryCodeList"
                optionLabelProp="value"
                v-decorator="[
                  `passengers[${psgIndex}].areaCode`,
                  { initialValue: '86' }
                ]"
              >
              </a-select>
            </a-input>
          </a-form-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import moment from 'moment'
import { orderCertificateMap, orderCertificateDomesticMap } from '@/dicts/order'
import passengerTooltip from '@/components/tooltip/passenger-tooltip'
const LOAD_NUM = 20

export default {
  name: 'passengerItem',
  props: {
    initValue: { type: Object },
    psgIndex: { type: Number },
    adultList: { type: Array },
    oriDataList: { type: Array },
    departureDate: [Date, String],
    passengerFieldInfo: { type: Array },
    passengerTypeInfo: { type: Array },
    ifInviteRegisterFfp: { type: Boolean, default: false }
  },
  components: {
    passengerTooltip
  },
  computed: {
    isInfant () {
      return this.initValue.passengerType === 'INF'
    }
  },
  watch: {
    adultList (value) {
      this.adultOptionList.length = 0
      for (let i = 0; i < value.length; i++) {
        this.adultOptionList.push(value[i])
      }
    },
    oriDataList: {
      handler () {
        this.updateData()
      },
      immediate: true
    },
    initValue: {
      handler: function (newValue) {
        if (newValue.idType) {
          this.onIdTypeChange(newValue.idType, this.psgIndex, false)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      isChecked: true,
      isInviteChecked: true,
      countryCodeList: [],
      adultOptionList: [],
      searchVal: '', // 搜索的内容
      filterDataList: [], // 过滤的数据列表 -- 从dataList中过滤出含搜索内容的数据
      renderedOptions: [], // 已渲染的下拉列表
      isDomestic: true,
      isDomesticNationality: true,
      moment,
      isAgent: [1, 2].includes(window.__MICRO_ROOT__?.user?.get()?.userType) || false,
      orderCertificateMap,
      orderCertificateDomesticMap
    }
  },
  mounted () {
    this.isChecked = this.initValue.isUsual
    // 异步加载，代码分离
    require.ensure([], (require) => {
      this.countryCodeList = require('@/assets/js/countrycode').default
    })
  },
  methods: {
    removePassenger (index) {
      if (index > 0) {
        this.$emit('removePassenger', index, true)
      }
    },
    startDate (departureDate) {
      return departureDate ? moment(departureDate).add(1, 'days') : null
    },
    startDisabledDate (current) {
      const { departureDate } = this
      return current && departureDate && current < moment(departureDate).endOf('day')
    },
    updateData () {
      this.renderedOptions = this.oriDataList.slice(0, LOAD_NUM)
    },
    handleFieldValidate (rule, value, callback) {
      this.$emit('inputItemValide', rule.fullField, value, callback)
    },
    setFullName (item = {}) {
      const { psgIndex } = this
      if (item.target) {
        const { id, value } = item.target
        this.$emit('setFullName', { id, value }, psgIndex)
      }
    },
    setUsual (e, index) {
      this.isChecked = e.target.checked
      this.$emit('setUsual', this.isChecked, index)
    },
    setInvite (e, index) {
      this.isInviteChecked = e.target.checked
      this.$emit('setInvite', this.isInviteChecked, index)
    },

    countryCodefilter (input, option) {
      return option.data?.attrs?.data.toLowerCase().indexOf(input) >= 0
    },
    getAdultList () {
      this.$emit('getAdultList', name)
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    onIdTypeChange (value, index, isManual) {
      this.isDomestic = ['NI', 'HM', 'ID26'].includes(value)
      this.$emit('idTypeChange', value, index, isManual)
    },
    // onNationalityChange (value, index) {
    //   this.isDomesticNationality = ['CN', 'HK', 'TW', 'MO'].includes(value)
    //   this.$emit('nationalityChange', value, index)
    // },
    getPassengerFieldInfo (type) {
      const { passengerFieldInfo = [] } = this
      const data = passengerFieldInfo?.find(item => { return item?.label === type }) || null
      return data
    },
    getPassengerTypeInfo (type) {
      const { passengerTypeInfo = [] } = this
      const data = passengerTypeInfo?.find(item => { return item?.label === type }) || null
      return data?.description
    },
    // 懒加载优化 select 数据过大产生的卡顿
    // 文本框值变化时触发 -- 从数据源中过滤出含搜索内容的数据，并取过滤结果的前n条作为下拉列表的可选项
    handleSearch (val) {
      const { oriDataList } = this
      const filterList = val ? oriDataList.filter(item => { return item.label.indexOf(val) > -1 }) : oriDataList
      this.searchVal = val
      this.filterDataList = filterList
      this.renderedOptions = filterList.length < LOAD_NUM ? filterList : filterList.slice(0, LOAD_NUM)
    },

    // 滚动时触发（防止抖动）
    handlePopupScroll: debounce(function () {
      const { searchVal, oriDataList, filterDataList } = this
      this.loadMoreData(searchVal === '' ? oriDataList : filterDataList)
    }, 400),

    // 加载更多数据到select框
    loadMoreData (dataList) {
      const renderedLen = this.renderedOptions.length // 已渲染的下拉列表长度
      const totalLen = dataList.length // 当前数据源的长度
      if (renderedLen < totalLen) {
        const addList = renderedLen + LOAD_NUM <= totalLen
          ? dataList.slice(renderedLen, renderedLen + LOAD_NUM)
          : dataList.slice(renderedLen, renderedLen + (totalLen % LOAD_NUM))
        this.renderedOptions = (this.renderedOptions).concat(addList)
      }
    },

    // 被选中时调用，参数为选中项的 value (或 key) 值
    handleSelect (val) {
      if (this.searchVal) {
        const selectedArr = this.oriDataList.filter(item => item.value === val) // 从数据源中过滤出下拉框选中的值，并返回一个数组
        const restList = this.oriDataList.filter(item => item.value !== val) // 从数据源中过滤出其他的值，返回一个数组
        const newList = selectedArr.concat(restList).slice(0, LOAD_NUM) // 将选中的元素放到下拉列表的第一位
        this.renderedOptions = newList // 更新已渲染的下拉列表
        this.searchVal = '' // 因为触发handleSelect函数时，会自动清空用户输入的内容。因此，searchVal需要重置。
      }
    }
  }
}
</script>
<style lang="less">
@import "formStyle";
</style>
